/**
 * Combines class names using array with params or list of params
 *
 * @param classNames array with class names or list of class names params
 * @returns string with class names
 */
export function cNs(
  ...classNames: Array<string | undefined | null | boolean> | [(string | undefined | null | boolean)[]]
) {
  return classNames
    .flat()
    .filter((className) => typeof className === 'string' && !!className)
    .join(' ');
}
